export enum FilesWorkflowNode {
    UploadScans = 1,
    UploadPhotos,
}
